import { memo } from 'react'

import { Text } from '@cash-me/react-components'

import { AccordionNoRadix } from 'components/accordionNoRadix'
import { Grid, Col } from 'components/grid'
import { SectionLabel } from 'components/section-label'
import { pushDataLayer } from 'utils/push-data-layer'

import { helpFaqs } from './data'
import * as S from './styles'

const Help = memo(() => (
  <S.Help>
    <Grid col={{ phone: 1, tablet: 1, desktop: 1 }}>
      <Col>
        <S.Content>
          <S.Header>
            <SectionLabel
              size="body1"
              weight="bold"
              color="white"
              barColor="var(--colors-blue-background-strong-default)"
            >
              Ajuda
            </SectionLabel>

            <Text as="h2" size="heading2" weight="medium" color="var(--colors-neutral-text-contrast-default)">
              Tem{' '}
              <Text as="span" size="heading2" weight="medium" color="var(--colors-cyan-text-contrast)">
                dúvidas
              </Text>{' '}
              sobre a CashMe?
            </Text>
          </S.Header>

          <S.Accordion>
            {helpFaqs.map(({ id, question, answer }) => (
              <div
                key={id}
                onClick={() =>
                  pushDataLayer({
                    category: 'Clique',
                    action: 'Ajuda',
                    label: `Accordion Pergunta: ${question}`
                  })
                }
              >
                <AccordionNoRadix
                  id={id}
                  chevronColor="var(--colors-neutral-text-contrast-default)"
                  title={
                    <Text as="h3" size="heading5" weight="medium" color="var(--colors-neutral-text-contrast-default)">
                      {question}
                    </Text>
                  }
                >
                  {answer}
                </AccordionNoRadix>
              </div>
            ))}
          </S.Accordion>
        </S.Content>
      </Col>
    </Grid>
  </S.Help>
))

Help.displayName = 'Help'

export default Help
